const BulmaPasswordInput = r => require.ensure([], () => r(require('./BulmaPasswordInput.vue')), 'shared')

export default BulmaPasswordInput
